const Incognito = ({ ...props }) => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.8615 33.2491C25.8615 32.2693 25.4723 31.3296 24.7795 30.6368C24.0866 29.9439 23.1469 29.5547 22.1671 29.5547C21.1873 29.5547 20.2476 29.9439 19.5547 30.6368C18.8619 31.3296 18.4727 32.2693 18.4727 33.2491"
        stroke="url(#paint0_radial_4376_9200)"
        stroke-width="2.1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M35.0965 20.3181L31.1988 8.0211C31.0282 7.53 30.7559 7.08044 30.3996 6.7018C30.0433 6.32317 29.6111 6.024 29.1313 5.82384C28.6515 5.62368 28.1348 5.52705 27.6151 5.54026C27.0954 5.55346 26.5843 5.67622 26.1153 5.90049L23.7582 7.0273C23.2609 7.2646 22.7169 7.38768 22.1659 7.38751H15.7006C14.8959 7.38734 14.1131 7.64995 13.4712 8.13542C12.8294 8.62088 12.3636 9.30265 12.1447 10.0771L9.23535 20.3181"
        stroke="url(#paint1_radial_4376_9200)"
        stroke-width="2.1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.69434 20.3203H40.6388"
        stroke="url(#paint2_radial_4376_9200)"
        stroke-width="2.1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M31.402 38.7904C34.4626 38.7904 36.9437 36.3093 36.9437 33.2487C36.9437 30.1881 34.4626 27.707 31.402 27.707C28.3414 27.707 25.8604 30.1881 25.8604 33.2487C25.8604 36.3093 28.3414 38.7904 31.402 38.7904Z"
        stroke="url(#paint3_radial_4376_9200)"
        stroke-width="2.1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.9303 38.7904C15.9909 38.7904 18.472 36.3093 18.472 33.2487C18.472 30.1881 15.9909 27.707 12.9303 27.707C9.86976 27.707 7.38867 30.1881 7.38867 33.2487C7.38867 36.3093 9.86976 38.7904 12.9303 38.7904Z"
        stroke="url(#paint4_radial_4376_9200)"
        stroke-width="2.1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <defs>
        <radialGradient
          id="paint0_radial_4376_9200"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(7.38889 3.69444 -3.69444 2.9292 18.4727 29.5547)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFB45F" />
          <stop offset="1" stop-color="#FF8700" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_4376_9200"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(25.8611 14.779 -12.9306 11.7178 9.23535 5.53906)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFB45F" />
          <stop offset="1" stop-color="#FF8700" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_4376_9200"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(36.9444 1 -18.4722 0.792867 3.69434 20.3203)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFB45F" />
          <stop offset="1" stop-color="#FF8700" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_4376_9200"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(11.0833 11.0833 -5.54167 8.78761 25.8604 27.707)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFB45F" />
          <stop offset="1" stop-color="#FF8700" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_4376_9200"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(11.0833 11.0833 -5.54167 8.78761 7.38867 27.707)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFB45F" />
          <stop offset="1" stop-color="#FF8700" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default Incognito;
